import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import HomePage from '../views/HomePage.vue'
import AppChatbot from '../views/AppChatbot.vue'
import MailSecurity from '../views/MailSecurity.vue'
import AdminOrganizations from '../views/admin/AdminOrganizations.vue'

const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: { requiresAuth: true },
    redirect: '/jarvin', // Redirect / to the default child
    children: [
      {
        path: 'jarvin',
        name: 'Jarvin',
        component: AppChatbot,
        meta: { title: 'Jarvin' }
      },
      {
        path: 'mail-security',
        name: 'MailSecurity',
        component: MailSecurity
      },
      {
        path: 'admin/organizations',
        name: 'AdminOrganizations',
        component: AdminOrganizations,
        meta: { requiresAdmin: true }
      },
      {
        path: 'google-workspace/status',
        name: 'GoogleWorkspaceStatus',
        component: () => import('@/views/google-workspace/GoogleWorkspaceStatus.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'google-workspace/nouveautes',
        name: 'GoogleWorkspaceNouveautes',
        component: () => import('@/views/google-workspace/GoogleWorkspaceNouveautes.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'google-workspace/release-calendar',
        name: 'GoogleWorkspaceReleaseCalendar',
        component: () => import('@/views/google-workspace/GoogleWorkspaceReleaseCalendar.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'google-workspace/admin-tool',
        name: 'GoogleWorkspaceAdminTool',
        component: () => import('@/views/google-workspace/AdminTool.vue'),
        meta: { requiresAuth: true }
      },

    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

import { useAuthStore } from '@/stores/auth';

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);

  if (requiresAdmin && !authStore.isAdmin) {
    console.warn('Admin access required for this route.');
    next('/login'); // Redirect to login if not admin
  } else if (requiresAuth && !authStore.isAuthenticated) {
    // Store the intended path to redirect back after login
    localStorage.setItem('returnUrl', to.fullPath);
    next('/login'); // Redirect to login if not authenticated
  } else {
    next();
  }
});

export default router
